export default __webpack_public_path__ + "static/media/dress10.42d8ab6d.jpeg";